import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminOrderProductResponse {
  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Number)
  public readonly quantity!: number;
}
